/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Conscience {
    CLEAR = 'clear',
    CONFUSED = 'confused',
    COMA = 'coma',
    DELIRIUM = 'delirium',
}
